<template>
  <MonitorWrapper class="vp-100">
    <el-row :gutter="20" type="flex" align="middle">
      <el-col :span="12">
        <info-block title="设备状态实时信息">
          <template #titleRight>
            <div style="color: #9fceff">
              设备运行状态：
              <span class="state" :class="wsData.runstate | runstateClass(true)">
                {{ wsData.runstate | runstateText }}
              </span>
            </div>
          </template>
          <template #content>
            <el-row class="block-content state-block">
              <el-col :span="12">
                <div
                  style="
                    width: 70%;
                    margin: 0 auto;
                    display: flex;
                    justify-content: center;
                    font-size: 26px;
                  "
                >
                  <ModsIcon icon="icon-dupin" :wsData="wsData" :mods="curMod" />
                </div>
              </el-col>
              <el-col :span="12">
                <div>
                  <span>设备状态:</span>
                  <span class="state" :class="wsData.state | stateClass(true)">
                    {{ wsData.state | stateText }}
                  </span>
                </div>
                <div>
                  <span>设备名称:</span>
                  <span>{{ wsData.name }}</span>
                </div>
                <div>
                  <span>设备编号:</span>
                  <span>{{ sn }}</span>
                </div>
              </el-col>
            </el-row>
          </template>
        </info-block>
      </el-col>
      <el-col :span="12">
        <info-block title="PID曲线">
          <template #titleRight>
            <div style="color: #9fceff">PID: {{ pidValue }}(PPM)</div>
          </template>
          <template #content>
            <div class="block-content" style="overflow: hidden">
              <v-chart :options="lineOp" :autoresize="true"></v-chart>
            </div>
          </template>
        </info-block>
      </el-col>
    </el-row>
  </MonitorWrapper>
</template>

<script>
import { mapState } from 'vuex';
import InfoBlock from '../components/info-block';
import { lineAreaStyle } from '@/echartOption/lineAreaStyle';
import { graColor } from '@/views/realdata/FCBR-100/options';
import ModsIcon from '@/components/mods-icon';
import singleDeviceMixin from '@/mixins/singleDeviceMixin';

export default {
  name: 'VP100',
  components: {
    InfoBlock,
    ModsIcon
  },
  mixins: [singleDeviceMixin],
  data() {
    return {
      lineOp: lineAreaStyle({
        color: '#16F9CC',
        series: [{ areaStyle: { color: graColor('rgb(22, 249, 204)', 'rgba(32, 237, 255, 0.1)') } }]
      }),
      wsData: {},
      pidValue: '',
      curMod: 'tvocMod'
    };
  },
  computed: {
    ...mapState('history', ['historyDetailData', 'historyDetailDatas'])
  },
  methods: {
    updateData(newVal) {
      const { beginTime } = newVal;
      const { pidValue } = newVal.mods[this.curMod];
      this.pidValue = pidValue;
      this.wsData = newVal;
      this.lineOp.series[0].data.push([beginTime, pidValue]);
      if (this.lineOp.series[0].data.length > 20) {
        this.lineOp.series[0].data.shift();
      }
    },
    async initPage() {
      if (this.isHisDetail) {
        await this.getHistoryDetailData(this.eventId);
        this.wsData = this.historyDetailData;
        this.pidValue = this.historyDetailData.mods[this.curMod].pidValue;
        this.historyDetailDatas.forEach(ele => {
          this.lineOp.series[0].data.push([ele.beginTime, ele.mods[this.curMod].pidValue]);
        });
        this.hideLoading();
      }
    }
  },
  created() {
    this.initPage();
  }
};
</script>

<style lang="scss" scoped>
.vp-100 {
  height: 100%;
  .el-row {
    height: 100%;
    .el-col {
      height: 90%;
      .block-content {
        height: 100%;
        &.state-block {
          .el-col {
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            &:nth-child(2) {
              flex-direction: column;
              justify-content: center;
              align-items: flex-start;
              font-size: 20px;
              font-weight: bold;
              color: #00a0e9;
              padding-left: 20px;
              div {
                margin-bottom: 20px;
              }
            }
          }
        }
      }
    }
  }
  .state {
    @include state-textstyle;
  }
}
</style>
